var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabContext, TabList } from '@mui/lab';
import { Box, Drawer, IconButton, Tab, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Cancel01Icon, Comment01Icon, InformationCircleIcon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import { useLazyGetClientQuery } from '../../../../application/features/clients/client-api';
import useTranslate from '../../../../localization/helpers';
import ClientInfo from './tabs/clients-general-info';
import ClientMachine from './tabs/clients-machines';
import ClientWorkOrder from './tabs/clients-workorders';
var ClientDetail = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, clientId = _a.clientId, onGetDirections = _a.onGetDirections;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var _b = __read(useState('Assets'), 2), selectedTab = _b[0], setSelectedTab = _b[1];
    var _c = __read(useLazyGetClientQuery(), 2), triggerGetClient = _c[0], client = _c[1].data;
    useEffect(function () {
        if (clientId) {
            triggerGetClient(clientId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId]);
    var onTabChange = function (_event, newValue) { return setSelectedTab(newValue); };
    var handleCloseSideBar = function () {
        setIsOpen(false);
        setSelectedTab('Assets');
    };
    return (_jsxs(Drawer, { slotProps: {
            paper: {
                sx: {
                    width: { sm: '400px', xs: '100%' },
                    height: { sm: 'calc(100vh - 24px)', md: 'calc(100vh - 24px)', xs: '100%' },
                    overflow: 'hidden'
                }
            }
        }, anchor: isXs ? 'bottom' : isSm ? 'right' : 'right', variant: 'temporary', open: isOpen, onClose: function () { return setIsOpen(false); }, children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    borderRadius: '16px',
                    justifyContent: 'space-between',
                    padding: '16px 20px 16px 20px'
                }, children: [_jsx(Typography, { variant: 'h6', sx: { color: '#161C24' }, children: translate('clients.clientDetails') }), _jsx(IconButton, { onClick: handleCloseSideBar, children: _jsx(Cancel01Icon, {}) })] }), _jsx(Box, { sx: { width: '100%' }, children: _jsxs(TabContext, { value: selectedTab, children: [_jsxs(TabList, { onChange: onTabChange, centered: true, children: [_jsx(Tab, { iconPosition: 'start', icon: _jsx(Comment01Icon, {}), label: translate('common.assets'), value: 'Assets', sx: {
                                        borderRadius: '16px',
                                        bgcolor: selectedTab === 'Assets' ? '#FFFFFF' : 'transparent',
                                        color: selectedTab === 'Assets' ? '#161C24 !important' : '#454F5B !important'
                                    } }), _jsx(Tab, { icon: _jsx(InformationCircleIcon, {}), iconPosition: 'start', label: translate('common.info'), value: 'Info', sx: {
                                        borderRadius: '16px',
                                        bgcolor: selectedTab === 'Info' ? '#FFFFFF' : 'transparent',
                                        color: selectedTab === 'Info' ? '#161C24 !important' : '#454F5B !important'
                                    } })] }), client && _jsx(ClientMachine, { machines: client.machines }), client && _jsx(ClientInfo, { client: client, onGetDirections: function () { return onGetDirections(client); } }), client && _jsx(ClientWorkOrder, { workOrders: client.workOrders })] }) })] }));
};
export default ClientDetail;
